module.exports = __webpack_public_path__ + "img/footer5.ca0097ca.svg";